<script>
  export let stat = {};
  export let lastUpdate;
  export let invert = false;

  let icon = "same";
  let style = "stat is-same";
  let percent = "0";

  function getIcon() {
    if (!stat) return "same";
    const v = +stat.value.toFixed(3);
    const tolerance = 0.009;
    if (v > tolerance) {
      return "up";
    } else if (v < -tolerance) {
      return "down";
    }
    return "same";
  }

  function getPercent() {
    if (!stat) return "0";
    const p = +(stat.value * 100).toFixed(1);
    if (p > 0) {
      return "+" + p;
    }
    return "" + p;
  }

  $: {
    if (lastUpdate) lastUpdate.getTime(); // HACK
    icon = getIcon();
    style = "stat is-" + icon;
    percent = getPercent();
  }
</script>

<h1>{(stat || {}).title}</h1>
<p class={style}>{percent}%</p>
